import { createContext } from 'react';
import { DEFAULT_THEME } from '../constants';

const ThemeContext = createContext({ DEFAULT_THEME });

export default ThemeContext;
